import React from 'react';
import RouteListMustChangeBus from "@Route/components/Connection/RouteListMustChangeBus";
import datasetParser from "@Dataset/datasetParser";

interface StsBusChangeContainerProps {
    // ? is here so this can be used with PortalMap without errors
    index?: number
}

function StsBusChangeContainer({index}: StsBusChangeContainerProps) {
    const busChanges = datasetParser({className: 'gb--bus-change', index})

    return (
        <RouteListMustChangeBus
            busChange={busChanges?.stops}
        />
    );
}

export default StsBusChangeContainer;